import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

import { useCurrentTime } from '@entities/customer/@x/booking'
import { getDiffBetweenDates } from '@shared/lib/format'

import { getTimeToLessonStart } from '../lib/lesson-time-diff'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

interface LessonDaysToStartPayload {
  booking: ComputedRef<Booking>
}
interface LessonDaysToStartReturn {
  daysToStart: ComputedRef<number>
  daysLabel: ComputedRef<string>
  isToday: ComputedRef<boolean>
  isLessonStarted: ComputedRef<boolean>
}
export const useLessonDaysToStart = (payload: LessonDaysToStartPayload): LessonDaysToStartReturn => {
  const {
    currentTime,
  } = useCurrentTime()

  const daysToStart = computed(() => {
    const diff = getTimeToLessonStart(payload.booking.value.start, currentTime.value)
    const duration = dayjs.duration(diff)
    return Math.floor(duration.asDays())
  })

  const daysLabel = computed(() => {
    return `day${daysToStart.value === 1 ? '' : 's'}`
  })

  const isToday = computed(() => daysToStart.value <= 0)

  const isLessonStarted = computed(() => {
    return getDiffBetweenDates(payload.booking.value.start, currentTime.value).milliseconds <= 0
  })

  return {
    daysToStart,
    daysLabel,
    isToday,
    isLessonStarted,
  }
}
